import React from 'react';
import '../../style/Blog.css';
import { BiData, BiGitCompare, BiChip, BiBrain, BiRocket } from 'react-icons/bi';

const About = ({ onGoHome }) => {
  const goHome = () => {
    if (typeof onGoHome === 'function') onGoHome();
  };

  return (
    <div className="about-workflow">
      <h1 className="blog-page-title about-page-title">ABOUT</h1>

      <section className="about-section">
        <h2 className="about-section-title">The firm</h2>
        <p className="about-section-body">
          Aberrest Partners is a New York based applied AI and machine learning firm founded in 2021 by two former Wall Street quants. We work with alternative investment managers on information systems that organize how the firm actually works — entities, relationships, and prior decisions — so AI use is confident and valuable in their portfolio and operations decisions.
        </p>
      </section>

      <section className="about-section">
        <h2 className="about-section-title">People</h2>
        <div className="about-person">
          <h3 className="about-person-name">Peter Chung</h3>
          <p className="about-person-role">Co-Founder and Principal Engineer</p>
          <p className="about-section-body">
            Peter Chung is the Co-Founder and Principal Engineer of Aberrest Partners,
            an AI/ML consulting group serving the asset management industry. In his
            role, Peter leads the design, development, and deployment of technology
            solutions for investment teams, including custom knowledge engines,
            document-to-model pipelines, and monitoring and watchlist systems. Prior to
            founding Aberrest Partners, he was Director of Client Portfolio Management
            for the Quantitative Investment Solutions group at Credit Suisse Asset
            Management. Before that, Peter was a Senior Portfolio Researcher at
            Bloomberg and Wells Fargo Securities. He earned his Bachelor&apos;s in Economics
            and History from New York University and his Master&apos;s in Finance from the
            McDonough School of Business at Georgetown University.
          </p>
        </div>
      </section>

      <section className="about-section about-section--how">
        <h2 className="about-section-title">How we work</h2>
        <p className="about-section-body">
          Delivery is fast and tailored, grounded in security, usability, scalability, and productivity.
          {' '}
          <span className="highlight" onClick={() => { window.location.href = 'mailto:projects@aberrest.com'; }}>
            Contact us to learn more.
          </span>
        </p>
        <ul className="workflow-list">
          <li className="workflow-item">
            <div className="workflow-item-title">
              00 Data, SOP, &amp; Scope
              <BiData className="workflow-icon" />
            </div>
            <div className="workflow-item-detail">
              Collect and organize foundational workflow information.
            </div>
          </li>
          <li className="workflow-item">
            <div className="workflow-item-title">
              01 Process Mapping
              <BiGitCompare className="workflow-icon" />
            </div>
            <div className="workflow-item-detail">
              Diagram and translate operational elements into AI primitives.
            </div>
          </li>
          <li className="workflow-item">
            <div className="workflow-item-title">
              02 Solution Synthesis
              <BiChip className="workflow-icon" />
            </div>
            <div className="workflow-item-detail">
              Engineer reasoning systems and orchestration for the workflow.
            </div>
          </li>
          <li className="workflow-item">
            <div className="workflow-item-title">
              03 Evaluation
              <BiBrain className="workflow-icon" />
            </div>
            <div className="workflow-item-detail">
              Workflow testing and user assessment of solution performance.
            </div>
          </li>
          <li className="workflow-item">
            <div className="workflow-item-title">
              04 Deployment
              <BiRocket className="workflow-icon" />
            </div>
            <div className="workflow-item-detail">
              Integrate the production system into a monitored environment.
            </div>
          </li>
        </ul>
        <div className="workflow-avail">
          Contact us about <a href="mailto:projects@aberrest.com" className="highlight">your project.</a>
        </div>
      </section>

      <div
        className="back-button about-panel-back-bottom"
        onClick={goHome}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            goHome();
          }
        }}
      >
        ← Home
      </div>
    </div>
  );
};

export default About;
